module.exports = {
          srcSet: __webpack_public_path__ + "059b007c2940bd3704fbefeaea38553f-428.png"+" 428w",
          images:[ {path: __webpack_public_path__ + "059b007c2940bd3704fbefeaea38553f-428.png",width: 428,height: 150}],
          src: __webpack_public_path__ + "059b007c2940bd3704fbefeaea38553f-428.png",
          toString:function(){return __webpack_public_path__ + "059b007c2940bd3704fbefeaea38553f-428.png"},
          
          width: 428,
          height: 150
        }